export const MAC_DOWNLOAD_URL =
  'https://github.com/imai-studio/imai-desktop/releases/latest';
/** Public listing is not live yet; keep the landing card hidden until Ops supplies a public target. */
export const IOS_DOWNLOAD_URL: string | null = null;

export type DownloadPlatform = 'mac' | 'ios' | 'other';

export function detectDownloadPlatform(
  userAgent: string,
  platform: string,
  maxTouchPoints = 0
): DownloadPlatform {
  const value = `${userAgent} ${platform}`.toLowerCase();
  if (
    value.includes('iphone') ||
    value.includes('ipad') ||
    value.includes('ipod')
  ) {
    return 'ios';
  }
  if (value.includes('mac')) {
    return platform === 'MacIntel' && maxTouchPoints > 1 ? 'ios' : 'mac';
  }
  return 'other';
}

export function downloadCardOrder(
  platform: DownloadPlatform
): ['mac' | 'ios', 'mac' | 'ios'] {
  return platform === 'ios' ? ['ios', 'mac'] : ['mac', 'ios'];
}
